import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import customTheme from '../../global/customTheme';

import OnwrApp from './OnwrApp';

// Provider
import AppProvider from '../../providers/AppProvider';

export default function RootContainer() {
  return (
    <MuiThemeProvider theme={customTheme}>
      <CssBaseline />
      <AppProvider>
        <OnwrApp />
      </AppProvider>
    </MuiThemeProvider>
  );
}
